import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const InputFormSearchIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-input-form-search-icon ${className}`, height: '17.058', viewBox: '0 0 17.049 17.058', width: '17.049', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M16,17.058a1.048,1.048,0,0,1-.745-.307L11,12.5v-.79l-.27-.28A6.519,6.519,0,0,1,6.5,13a6.712,6.712,0,0,1-1.105-.093,6.537,6.537,0,0,1-5.34-5.59A6.5,6.5,0,0,1,6.5,0a6.761,6.761,0,0,1,.822.051,6.492,6.492,0,0,1,4.109,10.68l.281.27H12.5l4.24,4.26a1.052,1.052,0,0,1-.744,1.8ZM6.5,2A4.5,4.5,0,1,0,11,6.5,4.505,4.505,0,0,0,6.5,2Z', fill: '#a1a7b2' }) })));
InputFormSearchIcon.propTypes = {
    className: propStr(),
};
InputFormSearchIcon.defaultProps = {
    className: '',
};
export default InputFormSearchIcon;
